import { ref, type Ref } from 'vue';
import { useRouter, useRuntimeConfig, useHead, useSeoMeta } from '#imports';

export interface MetaParams {
  title: Ref<string>;
  isIndexed?: Ref<boolean>;
  description?: Ref<string>;
  ogImage?: Ref<string>;
  ogType?: Ref<string>;
  canonicalUrl?: Ref<string>;
}

export const getHeader = (
  meta: MetaParams = {
    title: ref(''),
  },
  options: {
    showCanonical: boolean;
  } = {
    showCanonical: false,
  }
) => {
  const $router = useRouter();
  const $config = useRuntimeConfig();

  const canonicalUrl = () => {
    if (meta.isIndexed?.value === false && !options.showCanonical) {
      return undefined;
    }
    if (meta.canonicalUrl?.value) return meta.canonicalUrl.value;

    const url = new URL($config.public.baseUrl as string);
    url.pathname = $router.currentRoute.path;
    return url.toString();
  };

  useHead(() => {
    const canonical = canonicalUrl();
    if (!canonical) return {};

    return {
      link: [
        {
          rel: 'canonical',
          href: canonical,
        },
      ],
    };
  });

  const ogImage = () => {
    if (!meta.ogImage?.value) return undefined;
    return new URL(meta.ogImage?.value, $config.public.baseUrl).href;
  };

  const robots = () => (meta.isIndexed?.value === false ? 'noindex, follow' : 'index, follow');

  useSeoMeta({
    title: meta.title,
    robots,
    description: meta.description,
    ogUrl: canonicalUrl,
    ogTitle: meta.title,
    ogType: (meta.ogType as any) || ref('website'),
    ogImage,
    ogDescription: meta.description,
    // @ts-ignore
    'sitemap:title': meta.title,
    'nexus:title': meta.title,
    'nexus:description': meta.description,
  });
};
